import { UserRole, type User } from '@/types/global'
import {
  Ability,
  AbilityBuilder,
  createMongoAbility,
  PureAbility,
  type AbilityTuple,
  type AbilityClass,
  type MongoAbility,
  type MongoQuery
} from '@casl/ability'
import { context } from '.'

// export default function defineAbilityFor(
//   user: User
// ): MongoAbility<AbilityTuple<Actions, Subjects>, MongoQuery> {
//   const { can, cannot, build } = new AbilityBuilder(createMongoAbility)

//   if (user.halaqat_role === UserRole.ADMIN) {
//     can('manage', 'all') // read-write access to everything
//   } else {
//     can('read', 'all') // read-only access to everything
//   }

//   cannot('delete', 'Post', { published: true })

//   return build() as MongoAbility<AbilityTuple<Actions, Subjects>, MongoQuery>
// }

export const isStudentUser = (user: User | null | undefined) => {
  return user?.maqari_role === UserRole.STUDENT
}

export const permissions = (user: User | null | undefined) => {
  const { can, cannot, build } = new AbilityBuilder<
    MongoAbility<AbilityTuple<Actions, Subjects>, any>
  >(createMongoAbility)

  const role = user?.maqari_role

  if (role === UserRole.ADMIN) {
    can('manage', 'Presence')
    can('create', 'Students')
    can('create', 'Sessions')
    can('edit', 'Sessions')
    can('edit', 'Students')
    can('transfer', 'Students')
    can('manage', 'Absences')
    can('view', 'AdminStats')
    can('view', 'Stats')
    can('manage', 'Visits')
    can('manage', 'Observability')
    can('manage', 'Students')
    can('manage', 'Teachers')
    can('manage', 'Administrators')
    can('manage', 'Sessions')
    can('manage', 'Evaluations')
    can('manage', 'Settings')
    can('delete', 'Students')
    can('archive', 'Students')
    can('unarchive', 'Students')
    can('delete', 'Sessions')
    can('archive', 'Sessions')
    can('unarchive', 'Sessions')
    can('delete', 'Teachers')
    can('archive', 'Teachers')
    can('unarchive', 'Teachers')
  }

  if (role === UserRole.TEACHER) {
    cannot('manage', 'Teachers')
    cannot('manage', 'Settings')
    can('edit', 'Students')
    cannot('manage', 'Absences')
    can('manage', 'Evaluations')
    can('view', 'Sessions')
    cannot('create', 'Sessions')
    cannot('edit', 'Sessions')
    can('view', 'Stats')
    can('manage', 'Students')
    cannot('delete', 'Students')
    cannot('archive', 'Students')
    cannot('unarchive', 'Students')
    cannot('delete', 'Sessions')
    cannot('archive', 'Sessions')
    cannot('unarchive', 'Sessions')
    cannot('delete', 'Teachers')
    cannot('archive', 'Teachers')
    cannot('unarchive', 'Teachers')
  }

  if (isStudentUser(user)) {
    can('view', 'StudentPortal')
    can('update', 'Presence')
  }

  if (role !== UserRole.TEACHER && role !== UserRole.ADMIN) {
    cannot('manage', 'Students')
    cannot('manage', 'Sessions')
    cannot('manage', 'Evaluations')
    cannot('view', 'Stats')
  }

  return build()
}

type Actions =
  | 'create'
  | 'manage'
  | 'edit'
  | 'view'
  | 'transfer'
  | 'update'
  | 'delete'
  | 'archive'
  | 'unarchive'
type Subjects =
  | 'Presence'
  | 'Students'
  | 'Sessions'
  | 'Absences'
  | 'AdminStats'
  | 'Visits'
  | 'Observability'
  | 'Teachers'
  | 'Administrators'
  | 'Evaluations'
  | 'Stats'
  | 'StudentPortal'
  | 'Settings'
